import MainInfoLoader from './MainInfoLoader';

export default MainInfoLoader;
